import {Check} from 'lucide-react'
import {cn} from '@/lib/utils'

export interface WizardStep {
    id: string
    title: string
}

interface WizardStepperProps {
    steps: WizardStep[]
    currentStep: number
}

export function WizardStepper({steps, currentStep}: WizardStepperProps) {
    return (
        <nav aria-label="wizard-steps" className="mb-8 pb-6">
            <ol className="flex items-center justify-center">
                {steps.map((step, index) => {
                    const isCompleted = index < currentStep
                    const isActive = index === currentStep
                    const isLast = index === steps.length - 1

                    return (
                        <li key={step.id} className="flex items-center">
                            <div className="relative flex items-center justify-center">
                                <div
                                    aria-current={isActive ? 'step' : undefined}
                                    className={cn(
                                        'relative z-10 flex h-8 w-8 items-center justify-center rounded-full text-sm font-medium transition-colors',
                                        isCompleted && 'bg-primary text-primary-foreground',
                                        isActive && 'bg-primary text-primary-foreground ring-2 ring-primary ring-offset-2',
                                        !isCompleted && !isActive && 'bg-muted text-muted-foreground'
                                    )}
                                >
                                    {isCompleted ? <Check className="h-4 w-4"/> : <span>{index + 1}</span>}
                                </div>
                                <span
                                    className={cn(
                                        'absolute top-full mt-1.5 left-1/2 -translate-x-1/2 text-xs font-medium whitespace-nowrap',
                                        isActive ? 'text-primary' : 'text-muted-foreground'
                                    )}
                                >
                                    {step.title}
                                </span>
                            </div>
                            {!isLast && (
                                <div className={cn('h-0.5 w-12 sm:w-20', isCompleted ? 'bg-primary' : 'bg-muted')}/>
                            )}
                        </li>
                    )
                })}
            </ol>
        </nav>
    )
}
